ALKMaps.Control.YardGateDragFeature = ALKMaps.Class(ALKMaps.Control.DragFeature, {
  initialize: function (layer, options) {
    ALKMaps.Control.DragFeature.prototype.initialize.apply(this, arguments);
    this.handlers.feature.featureAttributesFilter = this.featureAttributesFilter;
  },

  CLASS_NAME: "ALKMaps.Control.YardGateDragFeature"
});



// WEBPACK FOOTER //
// ./app/alkmapsExtension/controlYardGateDragFeature.js